var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"css":false},on:{"before-appear":_vm.beforeEnter,"before-enter":_vm.beforeEnter,"appear":_vm.enter,"enter":_vm.enter,"leave":_vm.leave}},[_c('div',[(_vm.showChildren)?_vm._t("default"):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }